import { useTranslation } from 'react-i18next';

export default function formatSignText(signText: string): string {
  const { t } = useTranslation();
  return t(`sign.${signText}`);
}
